// Effective combat stats. A unit's Power/Life after static-aura
// adjustments (_auraStatDelta), floored at 0.
//
// SINGLE SOURCE OF TRUTH. Display HUDs, combat (atk/def), the death
// sweep (findDeadMinions) and the Lethal force-kill must agree on a
// unit's effective numbers. Otherwise a buff/debuff lands in one place
// and not another. This module exists because they DID drift: combat
// attack omitted the aura delta while combat life and the death sweep
// included it, so Jihad's +1 showed on the card but never struck, and a
// Lethal hit couldn't kill an aura-buffed minion.
//
// Codex "Power": a unit's power is BOTH its strike value and its damage
// capacity. Codex "Power" also: "Units may not have less than zero
// power." Hence Math.max(0, …).
//
// Pure. No React, no Three, no mutation.

// Effective attack power: live power (currentAttack, falling back to the
// printed baseAttack) plus the aura delta, floored at 0. Equipment
// bonuses (Lance) are layered on by the caller.
export function effectivePower(card) {
  if (!card) return 0;
  const base = Number(card.currentAttack ?? card.baseAttack ?? 0);
  return Math.max(0, base + (card._auraStatDelta || 0));
}

// Effective life / toughness: printed life (baseLife, falling back to
// baseAttack since Sorcery power == life) plus the aura delta, floored
// at 0. This is the threshold the death sweep compares damage against.
//
// Codex "Power": a unit's power is BOTH its strike value and its damage
// capacity, so a TEMPORARY power swing must move capacity too. The
// this-turn buff (Gift of the Wolf's buff_target) bumps currentAttack +
// records `_thisTurnAttackDelta`, and until-next-turn swings (Witch's
// Curse) record `_untilNextTurnAttackDelta`. Both fold in here so a
// 2→4 minion survives 3 damage (and a cursed minion dies sooner). The
// aura delta is already baked into baseLife's sibling _auraStatDelta.
export function effectiveLife(card) {
  if (!card) return 0;
  const base = Number(card.baseLife ?? card.baseAttack ?? 0);
  let temp = card._thisTurnAttackDelta || 0;
  if (Array.isArray(card._untilNextTurnAttackDelta)) {
    for (const rec of card._untilNextTurnAttackDelta) temp += (rec?.delta || 0);
  }
  return Math.max(0, base + (card._auraStatDelta || 0) + temp);
}
